export const resourceName = 'Permissão de Filial';
export const resourcePluralTitle = 'Permissões a Filiais';

export const resourceKey = 'acesso/filial';

export const idKey = 'id';

export const headers = [
  { key: 'id', title: 'ID' },
  { key: 'nomefilial', title: 'Filial' },
  { key: 'usuario', title: 'Usuário' },
  { key: 'usuarioliberacao', title: 'Liberação' },
  { key: 'dataliberacao', title: 'Data da liberação' },
];
